'use client'

import { withProductContextProvider } from '@src/quince-site-common/src/contexts/product-context'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { MiniPDPDS } from './mini-pdp-ds'
import { MiniPDPLegacy } from './mini-pdp-legacy'

import type { ProductPageContext } from '../../domains/MiniPDPContext'

const MiniPDP = (props: { pageData: ProductPageContext }) => {
  if (shouldUseDesignSystem()) {
    return <MiniPDPDS {...props} />
  }
  return <MiniPDPLegacy {...props} />
}

export default withProductContextProvider(MiniPDP)
